// window.smb = {...window?.smb}
// smb.appVersion = function(){
// 	var ua = window.navigator.userAgent.toLowerCase().split("kbank/");
//
// 	if (ua.length > 1) {
// 		return ua[1].split("\\|")[0].split(" ")[0];	//앱 버전 return
// 	} else {
// 		// return "0.0.0";									//기본값
// 		return "1.4.8";									//기본값
// 	}
// }();

// console.log('KBANK_APP_AGENT:' + smb.appVersion +',,,'+ window.navigator.userAgent);

// console.log(window.document)

// 기존 디바이스 체크 함수
export const appSafeAreaMargin = function appSafeAreaMargin(){
	// 250117 호출 시점 변경 (보류)
	// appSafeAreaMarginNew();
	// return;
	
	// console.log('돔완료시점 클래스 추가');
	// pc, mobile 체크
	var filter = 'win16|win32|win64|mac|macintel';
	if(navigator.platform){
		if(filter.indexOf(navigator.platform.toLowerCase()) < 0){
			// $('html').attr('class','mobile');
			$('html').addClass('mobile');
			//$('.kbank_tel_number').attr('href', 'tel:1522-1000');
			// } else if($(document).width() < 699) {
		} else if(screen.width < 699) {
			// $('html').attr('class','mobile pc_m');
			$('html').addClass('mobile pc_m');
		} else{
			$('html').addClass('pc');
			// $('html').attr('class','pc');
			//$('.kbank_tel_number').attr('href', '#;');
		}
	}

	// 디바이스 체크
	if($('html').hasClass('mobile')){
		if(navigator.userAgent.match(/iPhone|iPad|iPod/i)){
			$('html').addClass('ios');
			//iphoneX & App Version 1.2.21 Up
			if(typeof JUtilMobile !== 'undefined') {
				if(JUtilMobile.checkAppVer({compareVer : "1.2.21", cal:">"})){
					$('html').addClass('iphoneX');

					//퀵송금 예외사항
					if( $('.quickfoot').length > 0){
						$('.vari_btn > a').addClass('wh54');
					}
				}

				//iPhone Status Bar Expension
				// 버전바뀔때 function f_getStatusBarHeight() 안에 앱체크 버전도 바뀌어야함
				if(JUtilMobile.checkAppVer({compareVer : "1.3.5", cal:">"})){
					$('html').addClass('statusExpension'); //20210318 SR-1368 추가
					//f_layerbodyheight(); //20210318 SR-1368 추가
				}
			}
		}else{
			$('html').addClass('android');
			//android Status Bar Expension
			// 버전바뀔때 function f_getStatusBarHeight() 안에 앱체크 버전도 바뀌어야함
			if(typeof JUtilMobile !== 'undefined') {
				if(JUtilMobile.checkAppVer({compareVer : "9.3.5", cal:"="})){
					$('html').addClass('statusExpension'); //20210318 SR-1368 추가
					//f_layerbodyheight(); //20210318 SR-1368 추가
				}
			}
		}
	}
}

// 250117 호출 시점 변경 (보류)
export const appSafeAreaMarginNew = function appSafeAreaMarginNew(){
	//pc, mobile 체크
	var docHtml = window.document.querySelector('html'), filter = 'win16|win32|win64|mac|macintel';

	console.log('파싱시점 클래스 추가');

	if(navigator.platform){
		if(filter.indexOf(navigator.platform.toLowerCase()) < 0){
			docHtml.classList.add('mobile');
		} else if(screen.width < 699) {
			docHtml.classList.add('mobile');
			docHtml.classList.add('pc_m');
		} else{
			docHtml.classList.add('pc');
		}
	}

	// 디바이스 체크
	if(window.document.querySelector('html.mobile') != null){
		if(navigator.userAgent.match(/iPhone|iPad|iPod/i)){
			docHtml.classList.add('ios');
			//iphoneX & App Version 1.2.21 Up
			if(typeof JUtilMobile !== 'undefined') {
				if(JUtilMobile.checkAppVer({compareVer : "1.2.21", cal:">"})){
					docHtml.classList.add('iphoneX');
				}

				//iPhone Status Bar Expension
				// 버전바뀔때 function f_getStatusBarHeight() 안에 앱체크 버전도 바뀌어야함
				if(JUtilMobile.checkAppVer({compareVer : "1.3.5", cal:">"})){
					docHtml.classList.add('statusExpension'); //20210318 SR-1368 추가
					//f_layerbodyheight(); //20210318 SR-1368 추가
				}
			}
		}else{
			docHtml.classList.add('android');
			//android Status Bar Expension
			// 버전바뀔때 function f_getStatusBarHeight() 안에 앱체크 버전도 바뀌어야함
			if(typeof JUtilMobile !== 'undefined') {
				if(JUtilMobile.checkAppVer({compareVer : "9.3.5", cal:"="})){
					docHtml.classList.add('statusExpension'); //20210318 SR-1368 추가
					//f_layerbodyheight(); //20210318 SR-1368 추가
				}
			}
		}
	}
}

$(function(){
	appSafeAreaMargin();
});

// 250117 호출 시점 변경 (보류)
// if(window.document){
// 	appSafeAreaMargin();
// }

// 20210318 SR-1368 추가
// 디바이스 statusbar 높이값 반환
export const f_getStatusBarHeight = function () {
	var has_iosNotch = f_hasIosNotch(); // 20210406 SR-1368 추가
	var statusbarHight = 0;
	var ios_statusbarHight = 44;
	var android_statusbarHight = 24;

	// 20210406 SR-1368 추가
	if( !has_iosNotch ) {
		ios_statusbarHight = 20;
	}
	// end 20210406 SR-1368 추가

	appSafeAreaMargin();

	if( $('html').hasClass('mobile') && $('html').hasClass('statusExpension') ) {

		if(navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
			// IOS
			if(typeof JUtilMobile !== 'undefined') {
				if(JUtilMobile.checkAppVer({compareVer : "1.3.5", cal:">"})) {
					statusbarHight = ios_statusbarHight;
				}
			}
		} else {
			// ANDROID
			if(typeof JUtilMobile !== 'undefined') {
				if(JUtilMobile.checkAppVer({compareVer : "9.3.5", cal:"="})) {
					statusbarHight = android_statusbarHight;
				}
			}
		}

		// 퍼블 테스트용
		// 앱버전체크는 퍼블에서 불가하여 html확인용으로 추가
		// pc_m클래스는 퍼블에만 적용되기에 pc_m클래스 체크로 적용
		if( $('html').hasClass('pc_m') ) {
			if( navigator.userAgent.match(/iPhone|iPad|iPod/i) ) {
				// ISO
				statusbarHight = ios_statusbarHight;
			} else {
				// ANDROID
				statusbarHight = android_statusbarHight;
			}
		}
	}

	return statusbarHight;
}
// end 20210318 SR-1368 추가

// 20210406 SR-1368 추가
// 아이폰 노치 디자인 디바이스 체크
function f_hasIosNotch() {

	var has_notch = true;

	if( navigator.userAgent.match(/iPhone|iPad|iPod/i) ) {
		var ratio = window.devicePixelRatio || 1;
		var screen = {
			width : window.screen.width * ratio,
			height : window.screen.height * ratio,
		};
		
		// 6+, 6s+, 7+, 8+
		if( screen.width == 1242 && screen.height == 2208 ) {
			has_notch = false;
		}
		// 6+(확대), 6s+(확대), 7+(확대), 8+(확대)
		if( screen.width == 1125 && screen.height == 2001 ) {
			has_notch = false;
		}
		// 6, 6s, 7, 8, SE2세대
		if( screen.width == 750 && screen.height == 1334 ) {
			has_notch = false;
		}
		// 5, 5s, 5c, SE1세대
		// 6(확대), 6s(확대), 7(확대), 8(확대), SE1세대
		if( screen.width == 640 && screen.height == 1136 ) {
			has_notch = false;
		}
		// 4, 4s
		// 2G, 3G, 3GS
		if( screen.width == 320 && screen.height == 480 ) {
			has_notch = false;
		}
	}

	return has_notch;
}
// end 20210406 SR-1368 추가

// start : 20221103 SR-2070 퍼센트 텍스트 롤링 추가
export const fnRollingTxt  = function ( _target , _duration ) {
	var _text = $(_target).children(".txt");
	var _index = 1;
	var rolling = setTimeout(function run(){
		// _text.removeClass('on');
		// _text.eq(_index).addClass('on');
		// _index++;
		_text.hide();
		_text.eq(_index).show();
		_index++;
		if ( _index == _text.length) {
			_index = 0;
		}
		rolling = setTimeout(run, _duration);
	}, _duration );
}

export const planRolling = {
	timer : null,
	stopInterval : null,
	percent : 0,
	timeShare : [2, 4, 3, 1],
	timeIndex : 0,
	timeInterval : 0,
	callbackFn: null, // 240115 : stop 시 play의 콜백이 적용되지 않아서 추가 수정
	write : function(){
		$('[data-role="plan-rolling-percent"]').text(this.percent)
	},
	checkPoint : function(){
		var getRandom = function(range){
			return Math.floor(Math.random() * 10 + range)
		}
		return [getRandom(50), getRandom(70), getRandom(80), 100]
	},
	play : function(totalSecond, callback, maxNumber){ // FETASK-97 : 넘버카운터 제한  (파라미터 maxNumber값 추가)
		console.log('play')
		var maxNumber = maxNumber ? maxNumber : 100;
		var that = this
		var cp = that.checkPoint()
		var setTimeInterval = function(){
			var timeGap = that.timeIndex === 0 ? cp[that.timeIndex] : cp[that.timeIndex] - cp[that.timeIndex - 1]
			that.timeInterval = Math.floor(totalSecond * 100 * that.timeShare[that.timeIndex] / timeGap)
		}
		this.callbackFn = callback; // 240115 : stop 시 play의 콜백이 적용되지 않아서 추가 수정
		setTimeInterval()

		that.timer = setTimeout(function tick(){
			++that.percent
			for(var i=0; i<cp.length; i++){
				if(cp[i] >= that.percent){
					that.timeIndex = i
					break 
				}
			}


			setTimeInterval()
			if(that.percent > maxNumber){ // FETASK-97 : 넘버카운터 제한 추가
				that.init()
				callback && callback();
			}else{
				that.write()
				that.timer = setTimeout(tick, that.timeInterval)
			}
		}, 100)
	},
	init : function(){
		clearTimeout(this.timer)
		clearInterval(this.stopInterval)
		this.percent = 0
		this.timeIndex = 0
	},
	stop : function(_timer){ // 231101 : _timer 파라미터 추가  defalut : 10 ms
		var that = this
		_timer = _timer == undefined ? 10 : _timer;
		clearTimeout(this.timer)
		this.stopInterval = setInterval(function(){
			++that.percent

			if(that.percent > 100){
				that.init();
				that.callbackFn && $.isFunction(that.callbackFn) && that.callbackFn(); // 240115 : stop 시 play의 콜백이 적용되지 않아서 추가 수정
			}else{
				that.write()
			}
		}, _timer)
	}
}

//  end : 20221103 SR-2070 퍼센트 텍스트 롤링 추가
